import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ListItem, ListItemIcon, ListItemText, Typography } from '@material-ui/core';

import { SocialIcon } from 'components';
import { connectionPopup } from 'helpers';

import useStyles from './itemStyles';
import { Network } from 'api';

const ReachLinkedIn: FC = () => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <ListItem
      disableGutters
      onClick={() => connectionPopup(Network.Linkedin)}
      className={classes.connect}
    >
      <ListItemIcon className={classes.listIcon}>
        <SocialIcon provider="linkedin" />
      </ListItemIcon>
      <ListItemText disableTypography>
        <Typography display="inline" variant="body2">
          {t('user:connectToLinkedIn')}
        </Typography>
      </ListItemText>
    </ListItem>
  );
};

export default ReachLinkedIn;
